import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { AdvancesScreen } from '@/features/payroll-advances/advances-screen'
import type { AdvanceFilters, AdvanceStatus } from '@/features/payroll-advances/api'
import { hasGrant } from '@/lib/me'

const STATUSES: AdvanceStatus[] = [
  'requested',
  'approved',
  'rejected',
  'cancelled',
  'disbursed',
  'settled',
]

function isStatus(value: unknown): value is AdvanceStatus {
  return typeof value === 'string' && STATUSES.includes(value as AdvanceStatus)
}

export const Route = createFileRoute('/_authenticated/payroll/advances')({
  validateSearch: (search: Record<string, unknown>): AdvanceFilters => ({
    search: typeof search.search === 'string' && search.search ? search.search : undefined,
    employee_id:
      typeof search.employee_id === 'string' && search.employee_id ? search.employee_id : undefined,
    advance_id:
      typeof search.advance_id === 'string' && search.advance_id ? search.advance_id : undefined,
    status: isStatus(search.status) ? search.status : undefined,
    from: typeof search.from === 'string' && search.from ? search.from : undefined,
    to: typeof search.to === 'string' && search.to ? search.to : undefined,
    request: search.request === '1' ? '1' : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'salary_advance.view')) throw redirect({ to: '/' })
  },
  component: AdvancesRoute,
})

function AdvancesRoute() {
  const navigate = useNavigate()
  const params = Route.useSearch()
  return (
    <AdvancesScreen
      params={params}
      onParamsChange={(next) => void navigate({ to: '/payroll/advances', search: next })}
    />
  )
}
